export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 px-6 md:px-10 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Stylish%20modern%20boutique%20interior%20with%20colorful%20product%20displays%20on%20minimalist%20metal%20racks%2C%20bright%20natural%20skylight%20illuminating%20the%20space%2C%20contemporary%20retail%20design%20with%20living%20green%20wall%20and%20warm%20wooden%20accents%2C%20inviting%20shopping%20atmosphere%20with%20soft%20ambient%20glow&width=1800&height=800&seq=cta-v2-kakobuy-2026&orientation=landscape)`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/45"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <span className="inline-block px-3 py-1 text-xs font-medium text-background-50/90 bg-background-50/10 backdrop-blur-sm rounded-full mb-6">
          Ready to Start?
        </span>
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-4 drop-shadow-md">
          Ready to Explore the Latest Kakobuy Spreadsheet?
        </h2>
        <p className="text-sm md:text-base text-background-50/85 max-w-lg mx-auto mb-8 drop-shadow-sm">
          Browse our curated guides, discover popular products, and start shopping smarter today. The kakobuy spreadsheet is updated daily with fresh content.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-accent-500 text-background-50 font-semibold rounded-md hover:bg-accent-600 transition-all duration-200 active:scale-[0.98] whitespace-nowrap cursor-pointer text-sm md:text-base shadow-lg"
          >
            Kakobuy Spreadsheet
            <i className="ri-arrow-right-up-line ml-2"></i>
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-background-50 text-foreground-900 font-semibold rounded-md hover:bg-background-100 transition-all duration-200 active:scale-[0.98] whitespace-nowrap cursor-pointer text-sm md:text-base shadow-lg"
          >
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}